// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_iV","advertCardNum":"c-a_iW"};